'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import Star from '@/components/reviews/stars-rating/star';

import * as Styled from './style.css';

export type StarRatingProps = {
  readOnly: boolean;
  setRatingToStore?: (value: number) => void;
  ratingFromReview?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ setRatingToStore, readOnly, ratingFromReview }) => {
  const [rating, setRating] = useState(0);
  const [tempRating, setTempRating] = useState(ratingFromReview || 0);

  useEffect(() => {
    if (ratingFromReview) {
      setTempRating(ratingFromReview);
    }
  }, [ratingFromReview]);

  function handleRating(value: number) {
    if (readOnly) return;

    setRating(value);
    if (setRatingToStore) {
      setRatingToStore(value);
    }
  }

  return (
    <div className={Styled.StarsWrapper} itemScope itemID="#Rating">
      {Array.from({ length: 5 }, (_, i) => (
        <Star
          key={i}
          readOnly={readOnly}
          isFilled={tempRating ? tempRating >= i + 1 : rating >= i + 1}
          onRate={() => handleRating(i + 1)}
          onHoverIn={() => setTempRating(i + 1)}
          onHoverOut={() => setTempRating(0)}
        />
      ))}
      {!readOnly && (<Text>- оценка</Text>)}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([
          { reviewRating: {
            '@id': '#Rating',
            '@type': 'Rating',
            ratingValue: tempRating,
            bestRating: 5
          } },
        ]) }}
      />
    </div>
  );
};

export default observer(StarRating);
